import { IntlShape } from 'react-intl';
import { find } from 'lodash';

import { getTextWithSoftHyphens } from '@app/components';
import { langMessages } from '@app/translations';

import { MappedFacetValue, UnmappedFacetValue } from '../constants';
import languages from '../languages.json';

// Given a two or three-character language code, return a localized language name string
export const formatLanguageName = (
  code: string,
  $t: IntlShape['$t']
): string => {
  const language = find(
    languages,
    entry =>
      entry.alpha3 === code.toLowerCase() || entry.alpha2 === code.toLowerCase()
  );

  if (language === undefined) {
    return $t(langMessages.undefined);
  }

  if (langMessages[language.alpha3]) {
    return $t(langMessages[language.alpha3]);
  }

  return language.name;
};

export const getLanguageOptions = ({
  $t,
  languagesValues = [],
  withSoftHyphens = true,
}: {
  $t: IntlShape['$t'];
  languagesValues?: UnmappedFacetValue[];
  withSoftHyphens?: boolean;
}): MappedFacetValue[] =>
  languagesValues.map(({ id, totalRecords }) => ({
    label: withSoftHyphens
      ? getTextWithSoftHyphens(formatLanguageName(id, $t))
      : formatLanguageName(id, $t),
    value: id,
    count: totalRecords,
    id,
  }));
